import { FC } from 'react';
import { ConstraintContainer } from 'components/ConstraintContainer';

export const ExaminationPageLayout: FC = ({ children }) => {
  return <ConstraintContainer>{children}</ConstraintContainer>;
};
